import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  lifecycle,
  withHandlers,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import {
  Paper,
  Table,
  TableCell,
  TableRow,
  TextField
} from '@material-ui/core';
import ReactSelectMaterialUi from 'react-select-material-ui';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import { sendLogin } from '../../auth/Auth';
import {
  getGroupMenus,
  GET_GROUP_MENUS_SUCCESS,
  getChargeAmount,
  GET_CHARGE_AMOUNT_SUCCESS,
  postBudgetGochi,
  POST_BUDGET_GOCHI_SUCCESS
} from '../../actions/GochiMenus';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import SuccessDialog from '../../components/molecules/SuccessDialog';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginRight: 36
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1,
    padding: 40,
    paddingTop: 15,
    width: 'calc(100% - 240px)'
  },
  // end sidebar
  paperWhite: {
    padding: 20,
    marginBottom: 40
  },
  rowTitle: {
    // marginBottom: 10,
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15,
    maxWidth: 550,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  titlePage: {
    fontSize: 24,
    fontWeight: 'bold',
    padding: '15px 15px 0'
  },
  formControl: {
    marginBottom: 15,
    width: '100%'
  },
  subTitle: {
    fontWeight: '600',
    fontSize: 12,
    marginBottom: 10,
    color: '#000000'
  },
  subTitleLight: {
    fontSize: 12,
    marginBottom: 10,
    color: '#000'
  },
  textField: {
    position: 'relative'
  },
  disabled: {
    backgroundColor: 'lightgrey'
  },
  searchForm: {
    padding: '20px'
  },
  selectInput: {
    backgroundColor: '#FFF !important'
  },
  buttonSubmit: {
    marginLelf: '10px !important',
    height: 38
  },
  buttonCancel: {
    margin: '0px',
    height: 38,
    backgroundColor: '#FFF',
    color: '#000',
    boxShadow: 'none',
    '&:hover': {
      textDecoration: 'none',
      boxShadow: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    }
  },
  btnList: {
    display: 'flex',
    justifyContent: 'center'
  },
  btnLeft: {},
  btnRight: {
    marginLeft: '10px'
  },
  select: {
    width: '100%',
    height: 38,
    display: 'flex',
    backgroundColor: '#FFF'
  },
  alertMessage: {
    fontSize: 14,
    color: 'red',
    display: 'block'
  },
  mainPaper: {
    maxWidth: 550,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      groups: state.groups.groups
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroupMenus,
          getChargeAmount,
          postBudgetGochi
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('menu', 'setMenu', ''),
  withState('couponCount', 'setCouponCount', 1),
  withState('billQuantity', 'setBillQuantity', 1),
  withState('listMenus', 'setListMenus', []),
  withState('onSubmitting', 'setOnSubmitting', false),
  withState('finalAmount', 'setFinalAmount', 0),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('success', 'setSuccess', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const PostsGroup = enhance(
  ({
    classes,
    menu,
    couponCount,
    setMenu,
    setCouponCount,
    billQuantity,
    setBillQuantity,
    listMenus,
    setListMenus,
    location,
    actions,
    checkSession,
    onSubmitting,
    setOnSubmitting,
    finalAmount,
    setFinalAmount,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    success,
    setSuccess,
    history
  }) => {
    const budget = (location.state && location.state.budget) || {};
    function progressOkAction() {
      updateOpenProgress(false);
      setResultMessage('');
    }
    async function getListMenus() {
      updateOpenProgress(true);
      updateLoading(true);
      actions
        .getGroupMenus()
        .then(response => {
          checkSession(response);
          if (response.type === GET_GROUP_MENUS_SUCCESS) {
            const menus = response.payload.menus.filter(m => {
              return m.menuChildType !== 5;
            });
            setListMenus(menus);
          }
        })
        .catch(() => {
          console.log('Error getting group menus');
        })
        .finally(() => {
          updateOpenProgress(false);
          updateLoading(false);
        });
    }
    useEffect(() => {
      getListMenus();
    }, []);
    function monthToStr(m) {
      return m < 10 ? `0${m}` : m;
    }

    function handleChangeMenu(id) {
      const found = listMenus.find(item => item.menuId === id);
      setMenu(found);
      if (found && (found.menuCombo === 1 || found.menuLimitTotal === 1)) {
        setCouponCount(1);
      }
    }

    function submit() {
      updateOpenProgress(true);
      updateLoading(true);
      actions
        .postBudgetGochi({
          budgetId: budget.budgetId,
          menuId: menu.menuId,
          gochiCount: billQuantity,
          couponCount
        })
        .then(response => {
          checkSession(response);
          if (response.type === POST_BUDGET_GOCHI_SUCCESS) {
            updateOpenProgress(false);
            updateLoading(false);
            setSuccess(true);
          } else {
            setResultMessage('システムに問題が発生しました。');
          }
          updateLoading(false);
        })
        .catch(() => {
          console.log('Error post budget gochi');
        });
    }

    function getFinalAmount() {
      updateOpenProgress(true);
      updateLoading(true);
      actions
        .getChargeAmount({
          menuId: menu.menuId,
          gochiCount: billQuantity,
          counponCount: couponCount
        })
        .then(response => {
          checkSession(response);
          if (response.type === GET_CHARGE_AMOUNT_SUCCESS) {
            setFinalAmount(response.payload.chargeAmount);
            setOnSubmitting(true);
            updateOpenProgress(false);
          } else {
            setResultMessage('システムに問題が発生しました。');
          }
          updateLoading(false);
        })
        .catch(() => {
          console.log('Error getting charge amount');
        });
    }

    const totalAmount = menu
      ? menu.includedTaxPrice * couponCount * billQuantity
      : 0;

    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="新着記事" />
        <main className={classes.content}>
          <div className={classes.toolbar} style={{ display: 'none' }} />

          <Typography variant="h6" noWrap className={classes.title}>
            {!onSubmitting ? 'ごち発行' : 'ごち発行確認画面'}
          </Typography>

          <Paper className={classes.mainPaper} elevation={1}>
            {!onSubmitting ? (
              <div className={classes.searchForm}>
                <div className={classes.rowForm}>
                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>
                      付与対象月
                    </FormLabel>
                    <div>{`${budget.year}/${monthToStr(budget.month)}`}</div>
                  </FormControl>
                </div>
                <div className={classes.rowForm}>
                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>予算</FormLabel>
                    <div>
                      {budget.budgetAmount &&
                        budget.budgetAmount.toLocaleString()}
                    </div>
                  </FormControl>
                </div>
                <div className={classes.rowForm}>
                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>発行済額</FormLabel>
                    <div>
                      {budget.usedAmount && budget.usedAmount.toLocaleString()}
                    </div>
                  </FormControl>
                </div>
                <div className={classes.rowForm}>
                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>
                      発行可能残額
                    </FormLabel>
                    <div>
                      {budget.remainAmount &&
                        budget.remainAmount.toLocaleString()}
                    </div>
                  </FormControl>
                </div>
                <div className={classes.rowForm}>
                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <ReactSelectMaterialUi
                      required
                      label="メニュー選択"
                      InputLabelProps={{
                        style: {
                          color: '#000'
                        }
                      }}
                      className={classes.textField}
                      value={(menu && menu.menuId) || ''}
                      options={listMenus.map(item => ({
                        label: item.menuName,
                        value: item.menuId
                      }))}
                      variant="standard"
                      margin="normal"
                      onChange={v => {
                        handleChangeMenu(Number(v));
                      }}
                      SelectProps={{
                        isClearable: true,
                        msgNoOptionsMatchFilter: '一統するメニューがありません',
                        msgNoOptionsAvailable: '一統するメニューがありません'
                      }}
                    />
                  </FormControl>
                </div>
                <div className={classes.rowForm}>
                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitleLight}>
                      メニュー税込価格
                    </FormLabel>
                    <TextField
                      value={
                        (menu &&
                          menu.includedTaxPrice &&
                          `${menu.includedTaxPrice.toLocaleString()}円`) ||
                        ''
                      }
                      type="search"
                      className={`${classes.textField} ${classes.disabled}`}
                      variant="outlined"
                      size="small"
                      disabled
                    />
                  </FormControl>
                </div>
                <div className={classes.rowForm}>
                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitleLight}>
                      個数
                    </FormLabel>
                    <TextField
                      type="search"
                      className={`${classes.textField} ${
                        menu &&
                        (menu.menuCombo === 1 || menu.menuLimitTotal === 1)
                          ? classes.disabled
                          : ''
                      }`}
                      variant="outlined"
                      size="small"
                      value={couponCount}
                      disabled={
                        menu &&
                        (menu.menuCombo === 1 || menu.menuLimitTotal === 1)
                      }
                      onChange={e => {
                        const value =
                          parseInt(e.target.value.replace(/[^\d]/, ''), 0) ||
                          '';
                        if (value > 100000000) {
                          alert(
                            '予算の上限額を超えました。やり直してください。'
                          );
                        } else {
                          setCouponCount(value);
                        }
                      }}
                    />
                  </FormControl>
                </div>
                <div className={classes.rowForm}>
                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitleLight}>
                      発行枚数
                    </FormLabel>
                    <TextField
                      value={billQuantity}
                      type="search"
                      className={classes.textField}
                      variant="outlined"
                      size="small"
                      onChange={e => {
                        const value =
                          parseInt(e.target.value.replace(/[^\d]/, ''), 0) ||
                          '';
                        if (value > 100000000) {
                          alert(
                            '予算の上限額を超えました。やり直してください。'
                          );
                        } else {
                          setBillQuantity(value);
                        }
                      }}
                    />
                  </FormControl>
                </div>
                <div className={classes.rowForm}>
                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitleLight}>
                      発行税込価格
                    </FormLabel>
                    <TextField
                      value={`${totalAmount.toLocaleString()}円`}
                      type="search"
                      className={`${classes.textField} ${classes.disabled}`}
                      variant="outlined"
                      size="small"
                      disabled
                    />
                  </FormControl>
                </div>
                <div className={classes.btnList}>
                  <div className={classes.btnLeft}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.buttonCancel}
                      onClick={() => {
                        history.push('/budget_edit');
                      }}
                    >
                      キャンセル
                    </Button>
                  </div>
                  <div className={classes.btnRight}>
                    <Button
                      disabled={
                        !(
                          menu &&
                          couponCount &&
                          couponCount > 0 &&
                          billQuantity &&
                          billQuantity > 0
                        )
                      }
                      variant="contained"
                      color="primary"
                      onClick={getFinalAmount}
                      className={classes.buttonSubmit}
                    >
                      発行する
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className={classes.searchForm}>
                <Table className={classes.detailTable}>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      付与対象月
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {`${budget.year}/${monthToStr(budget.month)}`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      予算
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {budget.budgetAmount &&
                        budget.budgetAmount.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      発行済額
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {budget.usedAmount && budget.usedAmount.toLocaleString()}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      発行可能残額
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {budget.remainAmount &&
                        budget.remainAmount.toLocaleString()}
                    </TableCell>
                  </TableRow>

                  {/* submit info */}

                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      メニュー名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {menu && menu.menuName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      メニュー税込価格
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {(menu &&
                        menu.includedTaxPrice &&
                        `${menu.includedTaxPrice.toLocaleString()}円`) ||
                        ''}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      個数
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {couponCount}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      発行枚数
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {billQuantity}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      発行税込価格
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {`${totalAmount.toLocaleString()}円`}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      支払総額
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {`${finalAmount.toLocaleString()}円`}
                      {finalAmount > budget.remainAmount && (
                        <span className={classes.alertMessage}>
                          発行可能残額が不足です。 再度ご確認ください。
                        </span>
                      )}
                    </TableCell>
                  </TableRow>
                </Table>
                <div className={classes.btnList}>
                  <div className={classes.btnLeft}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.buttonCancel}
                      onClick={() => {
                        setOnSubmitting(false);
                      }}
                    >
                      戻る
                    </Button>
                  </div>
                  <div className={classes.btnRight}>
                    <Button
                      disabled={finalAmount > budget.remainAmount}
                      variant="contained"
                      color="primary"
                      onClick={submit}
                      className={classes.buttonSubmit}
                    >
                      発行する
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </Paper>
        </main>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        <SuccessDialog
          open={success}
          message="ごち発行を進んでいます。10分ほどお待ちください。"
          btnTitle="ごち発行一覧画面へ"
          okAction={() => {
            history.push('/supply_gochi_group');
          }}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(PostsGroup));
